<div class="dialog-content-wrapper" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary="body">
    <mat-toolbar [color]="'accent'" cdkDragHandle class="m-0"
             fxLayout="row" fxLayoutAlign="space-between center">
        <h2 mat-dialog-title class="title dialog-title m-0 p-0">{{ data?.company?.id ? ('workflows.formWidgets.company.dialogEditTitle' | translate) : ('workflows.formWidgets.company.dialogNewTitle' | translate) }}</h2>
            <button data-test="B-Close-dialog" [disabled]="isSaving" mat-icon-button
                    (click)="close()"
                    [attr.aria-label]="'common.closeDialogAria' | translate">
                <mat-icon>close</mat-icon>
            </button>
    </mat-toolbar>

    <div mat-dialog-content class="m-0" fusePerfectScrollbar fxFlex="100">
        <div [formGroup]="data?.companyFormGroup"
             fxLayout="row wrap"
             fxLayoutGap="12px grid">

            <mat-form-field [appearance]=data?.appearance fxFlex="100">
                <mat-label>{{ 'common.name' | translate }}</mat-label>
                <input matInput formControlName="name" required>
                <mat-error>{{ data?.companyFormGroup.get('name').errors | firstErrorMessage }}</mat-error>
            </mat-form-field>

            <ng-container *ngIf="showOptionalFields">
                <mat-form-field [appearance]=data?.appearance fxFlex="100">
                    <mat-label>{{ 'company.core.legalForm' | translate }}</mat-label>
                    <input matInput formControlName="form">
                </mat-form-field>
            </ng-container>

            <ng-container *ngIf="!data?.optionalFields || showOptionalFields">
                <mat-form-field [appearance]=data?.appearance fxFlex="100">
                    <mat-label>{{ 'person.core.street' | translate }}</mat-label>
                    <input matInput formControlName="street"  [required]="!data?.optionalFields">
                    <mat-error>{{ data?.companyFormGroup.get('street').errors | firstErrorMessage }}</mat-error>
                </mat-form-field>

                <mat-form-field [appearance]=data?.appearance fxFlex="50">
                    <mat-label>{{ 'person.core.postalCode' | translate }}</mat-label>
                    <input matInput formControlName="postCode"  [required]="!data?.optionalFields">
                    <mat-error>{{ data?.companyFormGroup.get('postCode').errors | firstErrorMessage }}</mat-error>
                </mat-form-field>

                <mat-form-field [appearance]=data?.appearance fxFlex="50">
                    <mat-label>{{ 'company.core.city' | translate }}</mat-label>
                    <input matInput formControlName="city"  [required]="!data?.optionalFields">
                    <mat-error>{{ data?.companyFormGroup.get('city').errors | firstErrorMessage }}</mat-error>
                </mat-form-field>
            </ng-container>

            <ng-container *ngIf="showOptionalFields">
                <mat-form-field [appearance]=data?.appearance fxFlex="100">
                    <mat-label>{{ 'common.email' | translate }}</mat-label>
                    <input matInput formControlName="mail" type="email">
                    <mat-error>{{ data?.companyFormGroup.get('mail').errors | firstErrorMessage }}</mat-error>
                </mat-form-field>

                <div formGroupName="phone" fxFlex="100" fxLayout="row wrap" fxLayoutGap="12px grid">
                    <mat-form-field [appearance]=data?.appearance fxFlex="60">
                        <mat-label>{{ 'common.phoneNumber' | translate }}</mat-label>
                        <input matInput formControlName="number">
                        <mat-error>{{ data?.companyFormGroup.get('phone').get('number').errors | firstErrorMessage }}</mat-error>
                    </mat-form-field>

                    <mat-form-field [appearance]=data?.appearance fxFlex="40">
                        <mat-label>{{ 'common.type' | translate }}</mat-label>
                        <mat-select formControlName="type">
                            <mat-option value="landline">{{ 'workflows.formWidgets.shared.phoneLandline' | translate }}</mat-option>
                            <mat-option value="mobile">{{ 'person.phoneNumbers.types.mobile' | translate }}</mat-option>
                            <mat-option value="fax">{{ 'person.phoneNumbers.types.fax' | translate }}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>

                <mat-form-field [appearance]=data?.appearance fxFlex="100">
                    <mat-label>{{ 'common.notes' | translate }}</mat-label>
                    <textarea matInput formControlName="note" rows="3"></textarea>
                    <mat-error>{{ data?.companyFormGroup.get('note').errors | firstErrorMessage }}</mat-error>
                </mat-form-field>
            </ng-container>

            <ng-container *ngIf="!showOptionalFields">
                <button fxFlex="100" class="p-0" mat-stroked-button color="accent"
                        [disabled]="isSaving"
                        (click)="showOptionalFields = true">
                    <mat-icon>visibility</mat-icon>
                    <span>{{ 'workflows.formWidgets.shared.showOptionalFields' | translate }}</span>
                </button>
            </ng-container>

        </div>
    </div>

    <div mat-dialog-actions class="m-16" fxLayout="row" fxLayoutAlign="space-between center">

        <button mat-button
                [disabled]="isSaving"
                (click)="close()">
            <mat-icon>cancel</mat-icon>
            <span>{{ 'common.cancel' | translate }}</span>
        </button>

        <button mat-flat-button color="accent"
                [disabled]="isSaving"
                (click)="save()">
            <ng-container *ngIf="isSaving; else notSaving">
                <mat-spinner class="saving-spinner" [diameter]="20"></mat-spinner>
            </ng-container>
            <ng-template #notSaving>
                <mat-icon>save</mat-icon>
                <span>{{ 'common.save' | translate }}</span>
            </ng-template>
        </button>

    </div>

</div>
